import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { ReportType } from "../../models";
import { RQ } from "../../globals/enums";
import { add } from "../../api/generic-api";

export const useAddReportType = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(
    (reportType: ReportType) => add<ReportType>("report-types", reportType),
    {
      onSuccess: (reportType) => {
        enqueueSnackbar("Report Type Added", { variant: "success" });
        queryClient.setQueryData<ReportType[]>(
          RQ.REPORT_TYPES,
          (reportTypes: ReportType[] | undefined) => {
            return [...(reportTypes ?? []), reportType];
          }
        );
      },
      onError: () => {
        enqueueSnackbar("Report Type Adding Error", { variant: "error" });
      },
    }
  );
};
